<template>
  <div>
    <!-- 상단 - 요청서 제목 / 스텝 / 저장 영역 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-full lp-content">
          <input v-model="estimate.title"  maxlength="30"
                 placeholder="새로운 견적요청서 이름을 입력하세요." style="margin-bottom:12px">
        </div>
        <div class="column is-full">
          <admin-form-item label="견적서 발송 방식">
            <div style="display:table">
              <div style="display:table-cell;padding-right:12px;padding-top:3px">
                <lp-check-bool :checkedVal.sync="estimate.sms"
                               label="견적서 문자 전송"></lp-check-bool>
              </div>
              <div style="display:table-cell;padding-right:12px;padding-top:3px">
                <lp-check-bool :checkedVal.sync="estimate.activate"
                               label="발행하기"></lp-check-bool>
                <div class="lp-admin-savedate-txt" v-if="estimate.updated_time">최근 저장일 {{ estimate.updated_time }}</div>
              </div>
            </div>
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="카테고리">
            <lp-adm-drop-input ref="adminput_prod"
                               :data.sync="catArr1"
                               :selectVal="selectedCategory(estimate.category1_id, 'cat1')"
                               @onSelect="res=>clickCategory(res.value, 'cat1')"
                               :placeholder="selectedCategory(estimate.category1_id, 'cat1')"
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

            <lp-adm-drop-input ref="adminput_prod"
                               :data.sync="cat2"
                               :selectVal="selectedCategory(estimate.category2_id, 'cat2')"
                               @onSelect="res=>clickCategory(res.value, 'cat2')"
                               :placeholder="selectedCategory(estimate.category2_id, 'cat2')"
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

            <lp-adm-drop-input ref="adminput_prod"
                               :data.sync="cat3"
                               :selectVal="selectedCategory(estimate.category3_id, 'cat3')"
                               @onSelect="res=>clickCategory(res.value, 'cat3')"
                               :placeholder="selectedCategory(estimate.category3_id, 'cat3')"
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>
      </div>
    </div>

      <!--&lt;!&ndash; 매핑시킬 카테고리 &ndash;&gt;
      <div class="column is-full">
        <div class="box">
          <admin-form-item label="매핑할 카테고리 목록">
            <lp-adm-drop-input :data.sync="form_catlist"
                               @onSelect="selCat"
                               placeholder="검색 후 선택"
                               width="160px"
                               listAlign="center"></lp-adm-drop-input>
          </admin-form-item>
          <div style="margin-top:8px" v-if="selected_category.length>0">
            <span style="font-size:0.9rem">선택된 카테고리</span>: <span v-for="cat, idx in selected_category" class="catlabel">{{ cat.label }} <i class="material-icons" @click="delCat(idx)" style="font-size: 0.9rem">close</i></span>
          </div>
        </div>
      </div>-->
    <div class="box lp-content">
      <!-- 스텝 상세 -->
      <!-- 스텝 -->
      <div class="steps">
        <div v-for="(step,idx) in estimate.steps" :key="'step-'+idx"
             class="step" @click.stop.prevent="clickStep(step,idx)"
             :class="{'step-select': step.selected}">{{ 'step'+(idx+1) }}
          <span class="step-remove-button material-icons" @click.stop.prevent="removeStep(idx)">remove_circle</span>
        </div>
        <div class="step" @click="addStep" v-if="estimate.steps.length < 5">+</div>
      </div>
      <input v-model="selectedStep.step.title" maxlength="50"
             :placeholder="'step'+ selectedStep.idx+'의 제목을 입력하세요'" style="margin-top:12px;margin-bottom:12px">
      <!-- form 구성 -->
      <block-forms :forms.sync="selectedStep.step.forms"
                   :saveAction="saveAction"
                   ref="block_forms"
                   @saveData="saveEstimate"></block-forms>
    </div>
  </div>
</template>

<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import BlockForms from "./component/BlockForms";
  import AdminFormItem from "../../../module/admin/AdminFormItem";

  export default {
    layout: 'Main',
    name: 'FormReg',
    components: {
      AdminFormItem,
      BlockForms,
      LpCheckBool,
      LpAdmDropInput
    },
    created() {
      if(this.$route.query.id)
        this.is_modify = true;
      // 최초 첫번째 스텝 선택
      this.selectedStep = {
        idx: 1,
        step: this.estimate.steps[0]
      }
      this.estimate.steps[0].selected = true;

      // 관리자 id 반영
      //this.estimate.admin_id = this.$store.getters.admin.username;

      /*this.$axios.get('admin/estimate/form/category').then(res=>{
        if(res.status===200){
          this.form_catlist = res.data;
        }
      })*/
      this.getCats();
      this.getData();
    },
    data() {
      return {
        // 카테고리
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        is_modify:false,
        // 선택된 스텝
        selectedStep: {
          idx: 0,
          step: undefined
        },
        // 클릭한 스탭 폼
        clickedForm: undefined,
        // 매핑할 카테고리 목록
        form_catlist: [
          {
            value:1,
            label:'웹 개발'
          },
          {
            value:2,
            label:'앱 개발'
          }
        ],
        estimate: {
          id: 0,
          admin_id: '',
          title: '',
          activate: true,
          sms: false,
          updated_date: '',
          category1_id: '',
          category2_id: '',
          category3_id: '',
          steps: [
            {
              title: '',
              selected: true,
              forms: []
            }
          ],
        },
        saveAction: false,
      }
    },
    watch:{
      'estimate.category1_id'(n){
        //console.log(n)
        this.cat2 = this.get_cat2();
      },
      'estimate.category2_id'(n){
        this.cat3 = this.get_cat3();
      }
    },
    methods: {
      getData(){
        // 수정할 요청서 가져오기
        let id = '';
        if(this.$store.getters.mode==='admin' && this.$route.query.id){
          id = this.$route.query.id;
          this.getFormDetail(id);
        }
        /*else if(this.$store.getters.mode==='partner'){
          id = this.$store.getters.partner.partner_id;
          this.getFormDetail(id);
        }*/
      },
      // 스텝 추가
      addStep() {
        //5개 까지만 추가
        if(this.estimate.steps.length==5) return;
        this.estimate.steps.push({
          title: '',
          selected: false,
          forms: []
        });
      },
      clickStep(step,idx) {
        this.estimate.steps.forEach(st => {
          st.selected = false;
        })
        step.selected = true;
        // this.selectedStep.step.selected = false;

        this.selectedStep = {
          idx: idx+1,
          step: step
        };
        this.$refs.block_forms.getOptList(this.selectedStep.step.forms);
      },
      removeStep(idx) {
        this.estimate.steps[idx-1].selected = true;
        this.selectedStep.step.selected = false;

        this.selectedStep = {
          idx: idx,
          step: this.estimate.steps[idx-1]
        }

        removeIndex(this.estimate.steps,idx);
      },
      // 폼 정보
      getFormDetail(id){
        this.estimate.steps = [];
        this.$axios.get(this.getUrl('estimate/form/' + id))
          .then(res => {
            if (res.status === 200) {
              this.estimate = res.data;

              this.selectedStep = {
                idx: 1,
                step: this.estimate.steps[0]
              }
              for (let i = 0; i < this.estimate.steps.length; i++) {
                if (i === 0) this.estimate.steps[i].selected = true;
                else this.estimate.steps[i].selected = false;
              }
              /*this.selected_category = res.data.categories;
              this.estimate.categories = [];
              for (let i = 0; i < this.selected_category.length; i++) {
                this.estimate.categories.push(this.selected_category[i].value);
              }*/
            }
          });

      },
      saveData () {
        this.saveAction = true;
      },
      // 저장
      saveEstimate() {
        // console.log(this.selectedStep);
        // return;
        let errMsg='';
        if(!this.estimate.title) errMsg = '견적요청서 이름을 입력해주세요.';

        if(errMsg){
          this.toast(errMsg);
          return;
        }
        let url = '';
        let params = '';
        let path = '';
        if(this.$store.getters.mode==='admin'){
          if(this.is_modify){
            url = this.getUrl('estimate/form')+'/'+this.$route.query.id;
            params = this.estimate;
            path = this.getPath('form');
            this.patchData(url, params, path);
          }
          else{
            url = this.getUrl('estimate/form');
            params = this.estimate;
            path = this.getPath('form');
            this.postData(url, params, path);
          }
        }
       /* else if(this.$store.getters.mode==='partner'){
          url = this.getUrl('estimate/form')+'/'+this.estimate.id;
          params = this.estimate;
          path = '/office/admin/form';
          this.patchData(url, params, path);
        }*/
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.estimate.category1_id = value;
          this.estimate.category2_id = '';
          this.estimate.category3_id = '';
        }
        else if (type === 'cat2') {
          this.estimate.category2_id = value;
          this.estimate.category3_id = '';
        }
        else if (type === 'cat3') {
          this.estimate.category3_id = value;
        }
      },
      selectedCategory(cat_id, type) {
        if (type === 'cat1' && cat_id) {
          for(let i=0; i<this.catArr1.length; i++) {
            if (this.catArr1[i].value === cat_id){
              return this.catArr1[i].label;
              break;
            }
          }
        }
        else if (type === 'cat2' && cat_id) {
          for(let j=0; j<this.cat2.length; j++) {
            if (this.cat2[j].value === cat_id){
              return this.cat2[j].label;
              break;
            }
          }
        }
        else if (type === 'cat3' && cat_id) {
          for(let x=0; x<this.cat3.length; x++) {
            if (this.cat3[x].value === cat_id){
              return this.cat3[x].label;
              break;
            }
          }
        }
      },
      get_cat2() {
        let cat = [];
        for (let i = 0; i < this.catArr2.length; i++) {
          if (this.catArr2[i].parent === this.estimate.category1_id) {
            cat.push(this.catArr2[i]);
          }
        }
        return cat;
      },
      get_cat3() {
        let cat = [];
        for (let i = 0; i < this.catArr3.length; i++) {
          if (this.catArr3[i].parent === this.estimate.category2_id) {
            cat.push(this.catArr3[i]);
          }
        }
        return cat;
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat2();
            this.cat3 = this.get_cat3();
          });
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-content input
    border 0
    border-bottom 1px solid #ddd
    padding 8px 0
    padding-bottom 2px
    border-radius 0
    font-size 0.9rem
    max-width 400px
    box-shadow 0 0 0
  .lp-content input:focus
    border-bottom 1px solid $primary


  .lp-admin-save-div
    display flex
    justify-content space-between
    background-color white
    padding 12px
    margin-bottom 20px

  .lp-admin-savedate-txt
    font-size 0.8rem
    color #555

  .lp-admin-save-btn
    width 52px
    color white
    background-color $primary
    text-align center
    padding 6px 8px
    font-size 0.9rem
    border-radius 3px
    display inline-block

  .steps
    flex 1
    //padding 0 40px
    display flex

  .step
    width 60px
    color $primary
    border 1px solid $primary
    border-radius 2px
    padding 6px 8px
    font-size 0.9rem
    text-align center
    margin auto 0
    margin-right 8px
    cursor pointer
    position relative

  .step:hover
  .step-select
    color white
    background-color $primary

  input[type=checkbox]
    width unset
    height 0.82rem

  input
    width 100%

  label
    font-size 0.9rem

  .step-remove-button
    position absolute
    z-index 10
    top -14px
    right -10px
    color $negative


</style>
